import api from "api";
import { supportApiBase } from "api/constants";
import { useQuery } from "react-query";
import { queryKeys } from "utils/misc";
import { TemplateListResponseDto } from "./templateDtos";
import { rolloutRefetchInterval } from "./catalogueDeployments";
import { CatalogueQuery, catalogueSearchParams } from "../components/CatalogueList";

type GetTemplatesParams = CatalogueQuery & { groups: string[] };

const buildQuery = (params: GetTemplatesParams): string => {
  const qs = catalogueSearchParams(params);
  params.groups.forEach(group => qs.append("group", group));
  return qs.toString();
};

export const useGetTemplates = (params: GetTemplatesParams) =>
  useQuery<TemplateListResponseDto>(
    [...queryKeys.templates(), params],
    () =>
      // @ts-ignore — v2 endpoint, not in OpenAPI types
      api.parse(`GET /treatments/schedules?${buildQuery(params)}`, { root: supportApiBase }),
    { keepPreviousData: true, refetchInterval: data => rolloutRefetchInterval(data?.items) }
  );
